import { render } from "./SupplyPerformance.vue?vue&type=template&id=241f99d5&scoped=true"
import script from "./SupplyPerformance.vue?vue&type=script&lang=js"
export * from "./SupplyPerformance.vue?vue&type=script&lang=js"

import "./SupplyPerformance.vue?vue&type=style&index=0&id=241f99d5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-241f99d5"]])

export default __exports__